import React, { Component } from 'react';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import PaymentDetailSettingsForm from './DetailSettingsForm';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

class KindergartenPaymentDetailDialog extends Component {

	constructor(props) {
		super(props);
		this.handlePaymentDetailSubmit = this.handlePaymentDetailSubmit.bind(this);
	}

	renderFooter() {
		const { t, onHide, isReadonly } = this.props;
		const closeBtn = <Button key='close' onClick={onHide}>{t('Common_Close')}</Button>;
		const saveBtn = <RemoteSubmitButton key='save' style='success' disabled={isReadonly} formName='kindergartenPaymentDetailForm' label={t('Common_Save')} icon={faCheck} />;
		return [closeBtn, saveBtn];
	}

	getInitialValues() {
		const { kindergartenPaymentDetail, lessonDate } = this.props;
		if (kindergartenPaymentDetail && kindergartenPaymentDetail.id) {
			return kindergartenPaymentDetail;
		} else {
			return { lessonDate };
		}
	}

	handlePaymentDetailSubmit(values) {
		const {
			onSubmit, kindergartenPaymentDetail, kindergartenPayment,
			events: {
				updatePaymentDetail, createPaymentDetail, createPaymentAndPaymentDetail
			}
		} = this.props;

		if (kindergartenPaymentDetail && kindergartenPaymentDetail.id) {
			// Kindergarten payment detail record exists - we update it
			updatePaymentDetail(kindergartenPaymentDetail.id, { ...kindergartenPaymentDetail, ...values });
		} else {
			if (kindergartenPayment.length > 0) {
				// Kindergarten payment detail record does not exist, but there is a kindergarten payment master record.
				// We create a new kindergarten payment detail record.
				createPaymentDetail({ ...values, kindergartenPaymentId: kindergartenPayment[0].id });
			} else {
				// Kindergarten payment detail record does not exist and there is no kindergarten payment master record.
				// We create the master record first and after that the payment detail record
				createPaymentAndPaymentDetail(values);
			}
		}
	};

	renderSettingsForm() {
		const { lessonDate, kindergartenPayment, onSubmit, t } = this.props;
		const initialValues = this.getInitialValues();
		return (
			<PaymentDetailSettingsForm
				onSubmit={this.handlePaymentDetailSubmit}
				initialValues={initialValues}
				kindergartenPayment={kindergartenPayment}
				t={t}
			/>
		);
	}

	configureDialog() {
		const { t, onHide } = this.props;
		const body = this.renderSettingsForm();
		return {
			header: t('KindergartenAttendance_KindergartenWeeklyPayment'),
			body,
			onHide: onHide,
			footer: this.renderFooter()
		};
	}

	render() {
		const { t, show } = this.props;
		const dialogConfig = this.configureDialog();

		return (
			<Dialog config={dialogConfig} show={show} t={t} />
		);
	};
}

export default KindergartenPaymentDetailDialog;